module.exports = __webpack_public_path__ + "static/media/pizza.75e5fb22.svg";